const INITIAL_STATE = {
  isLogged: false,
  userData: {},
};

export default function menu(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "SET_FIELD_USER":
      return {
        ...state,
        [action.field]: action.value,
      };
    default:
      return state;
  }
}
